import { EnvironmentOutlined } from '@ant-design/icons';
import { Button, Flex } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Location } from '@/models';

import { SelectMultipleLocations } from './SelectMultipleLocations';

type LocationListFooterProps = {
  locations: Location[] | undefined;
  onSubmit: (locationIds: string[]) => void;
};

export const LocationListFooter = ({ locations, onSubmit }: LocationListFooterProps) => {
  const [selectedLocations, setSelectedLocations] = useState<string[]>([]);
  const { t } = useTranslation();

  return (
    <Flex justify='space-between'>
      <SelectMultipleLocations
        selectedLocations={selectedLocations}
        locations={locations}
        onChange={(value) => setSelectedLocations(value)}
      />
      <Button
        aria-label={t('common:add')}
        type={'primary'}
        icon={<EnvironmentOutlined />}
        onClick={() => {
          onSubmit(selectedLocations);
          setSelectedLocations([]);
        }}
        disabled={selectedLocations.length === 0}
      >
        {t('common:add')}
      </Button>
    </Flex>
  );
};
